import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function BenefitsSection() {
  const benefits = ['Abres el refri y no “piensas”: armas.', 'Dejas de comprar ingredientes que mueren solos en un cajón.', 'Reduces delivery porque ya hay algo listo que no te da asco.', 'La cena deja de ser una negociación contigo misma.'];
  return <section className="py-24 px-6 bg-white" data-id="element-28">
      <div className="max-w-3xl mx-auto" data-id="element-29">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-30">
          <h2 className="text-3xl md:text-4xl font-bold text-warm-900 mb-12 text-center font-display" data-id="element-31">
            ¿QUÉ CAMBIA CUANDO HACES 2-1-1?
          </h2>

          <div className="space-y-6" data-id="element-32">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-start p-6 bg-warm-50 rounded-xl border border-warm-100" data-id="element-33">
                <CheckCircle2 className="w-6 h-6 text-teal-600 mt-1 mr-4 flex-shrink-0" data-id="element-34" />
                <p className="text-lg text-warm-900 font-medium" data-id="element-35">{benefit}</p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}